export default __webpack_public_path__ + "static/media/salami-papryka-kukurydza.da79c113.png";